import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { artworks } from "./artworks";

function Art() {
  const grouped = artworks.reduce((acc, art) => {
    (acc[art.year] = acc[art.year] || []).push(art);
    return acc;
  }, {});

  const years = Object.keys(grouped).sort((a, b) => b - a);

  return (
    <Container className="art-section">
      <div className="art-page">
        {years.map((year) => (
          <section key={year} className="art-year-section">
            <h2 className="art-year-heading">{year}</h2>
            <div className="art-grid">
              {grouped[year].map((art) => (
                <Link to={`/paintings/${art.id}`} key={art.id} className="art-grid-item">
                  <img src={art.images[0]} alt={art.title} />
                  <div className="art-grid-label">
                    <span className="art-grid-title">{art.title}</span>
                    <span className="art-grid-meta">{art.medium}, {art.size}</span>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </Container>
  );
}

export default Art;
